import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';

// Amplify
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

import axios from 'axios';
import VueAxios from 'vue-axios';
import CmsHelpers from '@/logic/cms/helpers';
import VueGtm from 'vue-gtm';
import ProfileHelpers from '@/logic/profile/helpers';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import './assets/scss/app.scss';
import awsExports from './aws-exports';

Vue.use(VueGtm, {
  id: 'GTM-5Q8FNJX',
  vueRouter: router,
});

Amplify.configure(awsExports);
Auth.configure(awsExports);
Vue.use(AmplifyPlugin, AmplifyModules);

axios.defaults.baseURL = process.env.VUE_APP_BASE_PATH;
Vue.use(VueAxios, axios);

Vue.use(CmsHelpers, {
  API_URL: process.env.VUE_APP_CMS_BASE_PATH,
});
Vue.use(ProfileHelpers);

require('./icons/icon.font.js');

Amplify.configure(awsExports);

Vue.use(Buefy, {
  customIconPacks: {
    lwm: {
      sizes: {
        default: 'is-small',
        'is-small': 'is-size-5',
        'is-medium': 'is-size-3',
        'is-large': 'is-size-1',
      },
      iconPrefix: 'lwm-',
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
